if (!customElements.get('header-message-component')) {
  class HeaderMessageComponent extends HTMLElement {
    /** @type {number|undefined} */
    #intervalId;
    #current = 0;
    /** @type {ResizeObserver|undefined} */
    #resizeObserver;
    /** @type {MutationObserver|undefined} */
    #removalObserver;

    connectedCallback() {
      this.#updateHeight();
      this.#observeHeight();
      this.#bindRotation();
    }

    disconnectedCallback() {
      this.#stop();
      this.#resizeObserver?.disconnect();
      this.#removalObserver?.disconnect();
      this.removeEventListener('pointerenter', this.#stop);
      this.removeEventListener('pointerleave', this.#start);
      document.removeEventListener(
        'visibilitychange',
        this.#handleVisibilityChange
      );
      document.body.style.setProperty('--header-message-height', '0px');
    }

    /** @returns {HTMLElement[]} */
    get slides() {
      return Array.from(
        this.querySelectorAll('.header-message__slide')
      );
    }

    /** @returns {number} */
    get intervalMs() {
      const value = Number.parseInt(
        this.getAttribute('data-interval') || '',
        10
      );
      if (Number.isNaN(value) || value < 1) return 5000;
      return value * 1000;
    }

    #bindRotation() {
      if (this.slides.length < 2) return;

      this.addEventListener('pointerenter', this.#stop);
      this.addEventListener('pointerleave', this.#start);
      document.addEventListener(
        'visibilitychange',
        this.#handleVisibilityChange
      );
      this.#start();
    }

    #start = () => {
      this.#stop();
      this.#intervalId = window.setInterval(() => {
        if (this.matches(':hover') || document.hidden) return;
        this.#show((this.#current + 1) % this.slides.length);
      }, this.intervalMs);
    };

    #stop = () => {
      if (this.#intervalId) {
        clearInterval(this.#intervalId);
        this.#intervalId = undefined;
      }
    };

    /** @param {number} index */
    #show(index) {
      this.#current = index;
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }

    #handleVisibilityChange = () => {
      if (document.hidden) {
        this.#stop();
        return;
      }
      this.#start();
    };

    #updateHeight() {
      document.body.style.setProperty(
        '--header-message-height',
        `${this.offsetHeight}px`
      );
    }

    #observeHeight() {
      this.#resizeObserver = new ResizeObserver(() => this.#updateHeight());
      this.#resizeObserver.observe(this);

      const section =
        this.closest('.section-header-message') || this.parentElement;
      if (!section || section === document.body) return;

      this.#removalObserver = new MutationObserver(() => {
        if (!document.body.contains(this)) {
          document.body.style.setProperty('--header-message-height', '0px');
          this.#removalObserver?.disconnect();
          this.#resizeObserver?.disconnect();
        }
      });
      this.#removalObserver.observe(
        section.parentElement || document.body,
        {
          childList: true,
          subtree: false,
        }
      );
    }
  }

  customElements.define('header-message-component', HeaderMessageComponent);
}
